// The link to Regional Intel (productivity reports per CAR, a separate site) as its `/from-layers` handoff
// expects it, contract v1: a plain new-tab link whose data rides in the fragment, which the browser never
// sends to a server, so nothing goes into a query string or a log. Only who the user is in LAYERS travels:
// the user id and, when there is one, the customer id — never the email, the roles, a token or the name.
// A v1 link proves nothing; Regional Intel keeps the signup pending until it confirms it with LAYERS.

const REGIONAL_INTEL_HANDOFF_PATH = '/from-layers'

const CONTRACT_VERSION = '1'

// What the contract accepts for `uid` and `cid` (LAYERS ids are integers, well inside it).
const CONTRACT_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

// The base is build configuration: an http(s) origin (and path), without a query or fragment of its own.
const BASE_URL_PATTERN = /^https?:\/\/[^?#\s]+$/i

const toContractId = value => {
  const id = typeof value === 'number' && Number.isFinite(value) ? String(value) : value
  return typeof id === 'string' && CONTRACT_ID_PATTERN.test(id) ? id : null
}

// null when there is nothing to link to: no (usable) base URL in this build, or no valid user id. An invalid
// customer id is only left out, as the key is optional.
export const buildRegionalIntelUrl = ({ baseUrl, userId, customerId }) => {
  const base = typeof baseUrl === 'string' ? baseUrl.trim().replace(/\/+$/, '') : ''
  const uid = toContractId(userId)
  if (!BASE_URL_PATTERN.test(base) || !uid) return null

  const cid = toContractId(customerId)
  const fragment = [['v', CONTRACT_VERSION], ['uid', uid], cid && ['cid', cid]]
    .filter(Boolean)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')

  return `${base}${REGIONAL_INTEL_HANDOFF_PATH}#${fragment}`
}
